import { render, staticRenderFns } from "./editMoment.vue?vue&type=template&id=4111bb4a&"
import script from "./editMoment.vue?vue&type=script&lang=js&"
export * from "./editMoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports